module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cookie",
    class: {
      'cookie_border': _vm.border
    }
  }, [_c('h3', {
    staticClass: "cookie__title"
  }, [_vm._v("Мы используем файлы cookie.")]), _c('p', {
    staticClass: "cookie__text"
  }, [_vm._v("Центр опережающей профессиональной подготовки использует cookie\n(файлы с данными о прошлых посещениях сайта) для ведения\nстатистики и для улучшения работы сайта в соответствии с\nполитикой конфиденциальности: "), _c('ExtLink', _vm._b({}, 'ExtLink', _vm.url, false))], 1), _c('Button', {
    attrs: {
      "color": "lime",
      "size": "small",
      "factor": 1.4
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cookie')
      }
    }
  }, [_vm._v("Понятно!")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91b338d6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/usecookie/UseCookie.vue
// module id = 51c2713ed087fa3a376a
// module chunks = 8